export default __webpack_public_path__ + "static/media/gallery-img-1.c1fdb5e0.png";